// http://ozinisle.blogspot.com/2010/03/strrigh-in-javascript.html
String.prototype.str_right = function(seperator) {
     return this.substring(this.lastIndexOf(seperator)+1, this.length)
};